<template>
    <div class="time-usage">

        <div class="employee-switcher">
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = ''" :class="{'selected': employeeWorkingFieldName === ''}">
                Alle medarbejdere
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Svend, funktionær'" :class="{'selected': employeeWorkingFieldName === 'Svend, funktionær'}">
                Svende, funktionær
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Svend, timelønnet'" :class="{'selected': employeeWorkingFieldName === 'Svend, timelønnet'}">
                Svende, timelønnet
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Lærling'" :class="{'selected': employeeWorkingFieldName === 'Lærling'}">
                Lærlinge
            </div>
        </div>
        
        <div class="row">
            <div class="col-lg-12">

                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="employees.timeUsage" />
                        Opsummering
                    </div>
                    <div class="placeholder padding">

                        <div class="row" v-if="!loading">
                            <div class="col-lg-3">
                                <pie
                                    headline="Hvad bruger vi tiden på?"
                                    :series="hoursDivision.series"
                                    :labels="hoursDivision.labels"
                                    :division="true"
                                    height="220px"
                                />
                            </div>
                            <div class="col-lg-3">
                                <pie
                                    headline="Fordeling af tid hos kunderne"
                                    :series="hoursWithCustomers.series"
                                    :labels="hoursWithCustomers.labels"
                                    :division="false"
                                    height="220px"
                                />
                            </div>
                            <div class="col-lg-3">
                                <pie
                                    headline="Fordeling af anden tid"
                                    :series="hoursWithoutCustomers.series"
                                    :labels="hoursWithoutCustomers.labels"
                                    :division="false"
                                    height="220px"
                                    v-if="hoursWithoutCustomers.labels && hoursWithoutCustomers.labels.length > 0"
                                />
                                <div v-else>
                                    <div class="headline" style="text-align:center;font-weight:600;font-family:'Open Sans', sans-serif;">
                                        Fordeling af anden tid
                                    </div>
                                    <div style="text-align:center;">
                                        <br>
                                        Ingen anden tid registreret
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <pie
                                    headline="Fordeling af fravær"
                                    :series="hoursExcluded.series"
                                    :labels="hoursExcluded.labels"
                                    :division="false"
                                    height="220px"
                                    v-if="hoursExcluded.labels && hoursExcluded.labels.length > 0"
                                />
                                <div v-else>
                                    <div class="headline" style="text-align:center;font-weight:600;font-family:'Open Sans', sans-serif;">
                                        Fordeling af fravær
                                    </div>
                                    <div style="text-align:center;">
                                        <br>
                                        Intet fravær registreret
                                    </div>
                                </div>
                            </div>
                        </div>

                        <box-loading height="350" v-else />

                    </div>
                </div>

            </div>
        </div>

        <employee-time-usage :employeeWorkingFieldName="employeeWorkingFieldName" />

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import * as timeUsageService from '@/services/timeUsageService'

export default {
    data () {
        return {
            employeeWorkingFieldName: '',
            loading: true,
            hoursDivision: {
                series: null,
                labels: null
            },
            hoursWithCustomers: {
                series: null,
                labels: null
            },
            hoursWithoutCustomers: {
                series: null,
                labels: null
            },
            hoursExcluded: {
                series: null,
                labels: null
            },
            chartOptions: {
                series: [],
                labels: [],
                colors: this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: '600px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: (value) => {
                            let percent = Math.round((value / this.total) * 100)
                            return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return this.$options.filters.rounded(val) + ' %'
                    }
                },
                legend: {
                    position: 'left'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    formatter: (value) => {
                                        let percent = Math.round((value / this.total) * 100)
                                        return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.data = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName
            }
            timeUsageService.all(params, (response) => {
                this.hoursDivision.series = response.data.hours_division.series
                this.hoursDivision.labels = response.data.hours_division.labels
                this.hoursWithCustomers.series = response.data.hours_with_customers.series
                this.hoursWithCustomers.labels = response.data.hours_with_customers.labels
                this.hoursWithoutCustomers.series = response.data.hours_without_customers.series
                this.hoursWithoutCustomers.labels = response.data.hours_without_customers.labels
                this.hoursExcluded.series = response.data.hours_excluded ? response.data.hours_excluded.series : []
                this.hoursExcluded.labels = response.data.hours_excluded ? response.data.hours_excluded.labels : []
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    components: {
        VueApexCharts,
        'employee-time-usage': require('./components/employeeTimeUsage.vue'),
        'pie': require('./components/pie.vue')
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        },
        total () {
            if (this.chartOptions.series.length > 0) {
                return this.chartOptions.series.reduce((a, b) => a + b, 0)
            }
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        },
        employeeWorkingFieldName: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// timeUsage.vue?79bf8ad4